module.exports = __webpack_public_path__ + "static/media/GuideToFileHandling.6d7fecf6.md";